export function formatPrice(priceInput, exchangeRate, exchangeRateMode, convertMode, withSeparator = true, showEurFirst = null) {

    const eurRate = parseFloat(exchangeRate || '1.95583');
    const mode = parseInt(exchangeRateMode || '1');
    // After conversion command, prices are stored in EUR, so always use 1
    // If convertMode is 0 or not set, override it to 1 since prices are now in EUR
    // This matches the backend logic in CurrencyExtension.php line 27
    const convertModeValue = convertMode === null || convertMode === undefined || convertMode === '0' || parseInt(convertMode) === 0 ? 0 : 1;
    const convertFromEur = convertModeValue;

    // Get showEurFirst from parameter or try to read from global config/environment
    // If not provided, check for a global variable or default to 0
    let showEurFirstValue = 0;
    if (showEurFirst !== null && showEurFirst !== undefined) {
        showEurFirstValue = parseInt(showEurFirst) || 0;
    } else if (typeof window !== 'undefined' && window.APP_SHOW_EUR_FIRST !== undefined) {
        showEurFirstValue = parseInt(window.APP_SHOW_EUR_FIRST) || 0;
    }

    let priceBGN, priceEUR;

    const rawPrice = parsePriceString(priceInput);

    if (convertFromEur === 1) {
        // Price is stored in EUR, convert to BGN for display
        priceEUR = rawPrice;
        priceBGN = rawPrice * eurRate;
    } else {
        // Price is stored in BGN, convert to EUR for display
        priceBGN = rawPrice;
        priceEUR = rawPrice / eurRate;
    }

    const formatHTML = (amount, currency) => {
      const isBGN = currency === 'лв.';
      const formatted = Number(amount).toFixed(2);
      const display = isBGN
          ? formatted.replace('.', ',') // BGN: comma
          : formatted;                 // EUR: dot

      const spacing = currency === '€' ? withSeparator ? '&nbsp;' : '' : '';

  //     return `${spacing}<span class="val">
  //     <span class="val-cost">${formatted}</span>
  //     <span class="val-currency">${currency}</span>
  // </span>`;

      return `<span class="val">
        <span class="val-cost">${display}</span>
        <span class="val-currency">${currency}</span>
        </span>`;

    };

    let separator = withSeparator ? "<span class=\"val-sep\">/</span>" : "";
    if (mode === 0) {
      return formatHTML(priceBGN, 'лв.');
    } else if (mode === 1) {
      // Show EUR first if configured, otherwise show BGN first
      if (showEurFirstValue === 1) {
        return `${formatHTML(priceEUR, '€')}${separator}${formatHTML(priceBGN, 'лв.')}`;
      } else {
        return `${formatHTML(priceBGN, 'лв.')}${separator}${formatHTML(priceEUR, '€')}`;
      }
    } else if (mode === 2) {
      return formatHTML(priceEUR, '€');
    }
    return formatHTML(priceBGN, 'лв.');
}

export function parsePriceString(priceString) {
    if (typeof priceString === 'number' ) return priceString;

    if (typeof priceString === 'string' )
        return Number(
            priceString
            .replace(/\s/g, '')       // remove spaces (including non-breaking)
            .replace('лв.', '')       // remove BGN currency
            .replace('€', '')         // remove Euro symbol
            .replace(',', '.')        // replace comma with dot for decimals
        ) || 0;
}
